// extracted by mini-css-extract-plugin
export var copyIcon = "_xq-2";
export var discountCard = "_xq-0";
export var discountCode = "_xq-3";
export var discountContent = "_xq-1";
export var loadingCard = "_xq-4";